export const SET_USER = 'SET_USER';
export const SET_BOT_RUNNING = 'SET_BOT_RUNNING';
export const USER_LOGOUT = 'USER_LOGOUT';